import React from 'react';
import { useSidebarState } from '@/hooks/useSidebarState';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function PageContainer({ children, className = '' }: PageContainerProps) {
  const { isCollapsed } = useSidebarState();

  return (
    <div className="min-h-screen bg-background">
      <div 
        className={`p-8 mx-auto transition-all duration-300 ${
          isCollapsed 
            ? 'max-w-[1400px] px-4' 
            : 'max-w-[1200px]'
        } ${className}`}
      >
        {children}
      </div>
    </div>
  );
}